import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from "react";
import { Icon } from "../../../../../../../base/icons/icon/index.js";
import { ScrollIntoView } from "../../../../../../../structures/others/scroll-into-view/index.js";
import PanelAccommodationPerson from "../../components/panel-accommodation-person/index.js";
import usePanelAccommodation from "../../hooks/usePanelAccomodation.js";
import * as S from "./styled.js";
const MobilePanelAccommodation = ({ config: { literals , maxPeople  } , goToLast =false , disableAges =false  })=>{
    const { roomLabel =''  } = literals ?? {};
    const { disableIncrement , rooms , deleteRoom  } = usePanelAccommodation(maxPeople);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "PanelAccommodation",
        children: [
            Children.toArray(rooms.map((room, roomIndex)=>/*#__PURE__*/ _jsxs(S.PanelAccommodationRoomsMobile, {
                    children: [
                        /*#__PURE__*/ _jsxs(S.PanelAccommodationRoomHeader, {
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    children: roomLabel?.replace('#number#', (roomIndex + 1).toString())
                                }),
                                roomIndex !== 0 && /*#__PURE__*/ _jsx(S.PanelAccommodationRoomHeaderDelete, {
                                    onClick: deleteRoom(roomIndex),
                                    children: /*#__PURE__*/ _jsx(Icon, {
                                        className: "nico-cancel"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(S.PanelAccommodationPanelBodyMobile, {
                            children: Children.toArray(room.people.map((person, personIndex)=>/*#__PURE__*/ _jsx(ScrollIntoView, {
                                    behavior: "smooth",
                                    block: "nearest",
                                    scrollToView: goToLast && personIndex === room.people.length - 1,
                                    children: /*#__PURE__*/ _jsx(PanelAccommodationPerson, {
                                        roomIndex: roomIndex,
                                        personIndex: personIndex,
                                        person: person,
                                        disableIncrement: disableIncrement,
                                        disableAges: disableAges
                                    })
                                })))
                        })
                    ]
                }))),
            /*#__PURE__*/ _jsx(S.PanelAccommodationPortalsMobile, {
                id: "panel-accommodation-portals",
                "data-testid": "PanelAccommodationPortal"
            })
        ]
    });
};
export default MobilePanelAccommodation;

//# sourceMappingURL=index.js.map